export const appPeople = "GAa";
export default {appPeople};